type ITableBills = {
    data: any[],
    _handleModalPam: any,
    loading?: boolean

}

const Table = (props: ITableBills) => {
    const { data, loading, _handleModalPam } = props;

    return (
        <div className='card-body py-3'>
            {/* begin::Table container */}
            <div className={`table-responsive ${loading ? 'table-loading-overlay' : ''}`}>
                {/* begin::Table */}
                <table className='table table-striped table-hover align-middle gs-0 gy-5'>
                    {/* begin::Table head */}
                    <thead>
                        <tr className="text-gray-400 fs-4">
                            <th className='px-3 py-7 min-w-50px '>Nº Solicitud</th>
                            <th className='px-3 py-7 min-w-100px '>Fecha Envio</th>
                            <th className='px-3 py-7 min-w-100px '>Nº Rol</th>
                            <th className='px-3 py-7 min-w-100px'>Nº PAM</th>
                            <th className='px-3 py-7 min-w-150px'>Fecha Alta</th>
                            <th className='px-3 py-7 min-w-100px'>Fecha Hospitalización</th>
                            <th className='px-3 py-7 min-w-100px'>Estado</th>
                            <th className='px-3 py-7 min-w-100px'>Motivo Rechazo</th>
                            <th className='px-3 py-7 min-w-md-200px'>Acciones</th>
                        </tr>
                    </thead>
                    {/* end::Table head */}
                    {/* begin::Table body */}
                    <tbody className="fs-6 text-gray-800">
                        {data.map((item: any, index: any) => (
                            <tr className="border-bottom" key={`${item?.solicitud}-${index}`}>
                                <th>
                                    {item?.solicitud}
                                </th>

                                <td className="px-3">
                                    {item?.fecha_envio}
                                </td>

                                <td className="px-3">
                                    {item?.rol}
                                </td>

                                <td className="px-3">
                                    {item?.numero_pam}
                                </td>

                                <td className="px-3">
                                    {item?.fecha_alta}
                                </td>

                                <td className="px-3">
                                    {item?.fecha_hospitalizacion}
                                </td>

                                <td className="px-3">
                                    {item?.estado}
                                </td>

                                <td className="px-3">
                                    {item?.motivo_rechazo}
                                </td>

                                <td className="px-3 text-center">
                                    <button type="button" className="btn btn-primaryamsm fs-7 py-1 py-md-3" onClick={() => _handleModalPam(item)}>PAM Actual</button>
                                </td>
                            </tr>

                        ))}

                        {[...Array(10 - data.length)].map((row, index) => (
                            <tr key={`complete-render-${index}`}>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                        ))}
                    </tbody>
                    {/* end::Table body */}
                </table>
                {/* end::Table */}
            </div>
            {/* end::Table container */}
        </div>
    )

}

export default Table;